module.exports = __webpack_public_path__ + "img/persia-Unselected.221149a7.webp";